import { action } from 'mobx';
import { API } from 'aws-amplify';
import moment from 'moment';
import { Client } from '../models/Client';
const uuidv4 = require('uuid/v4');

export class ClientStore {
  @action loadCurrentClients(): Promise<Client[]> {
    return API.get('restAPI', '/client/practitioner', {}).then(clientEntries => {
      console.log(clientEntries);
      
      const clients = clientEntries.map((client: Client) => {
        return new Client(client);
      });

      console.log(clients);
      return clients;
    }).catch((error) => {
      console.error(error);
      Promise.reject(error);
    });
  }

  @action public saveOrUpdate(client: Client): Promise<Client> {
    console.log('Saving or Updating client');
    const isNew: boolean = client.isNew(); 
    if (isNew) {
      client.id = uuidv4();
      client.createDate = moment().toISOString(true);
      client.lastModifiedDate = client.createDate;
    } else {
      client.lastModifiedDate = moment().toISOString(true);
    }
    
    console.log(client);

    let requestParams = {
      body : client
    };
    console.log(requestParams);

    return API.post('restAPI', '/client/practitioner', requestParams).then(updatedClient => {
      console.log(updatedClient);
      return new Client(updatedClient);
    }).catch((error) => {
      console.error(error);
      // If new then clear id, createDate and lastModifiedDate
      if (isNew) {
        client.id = undefined;
        client.createDate = undefined;
        client.lastModifiedDate = undefined;
      }
      return Promise.reject(error);
    });
  }

  async deleteClient(client: Client): Promise<any> {
    const init = {
      queryStringParameters: client.key
    };
    return await API.del('restAPI', '/client', init);
  }
}